export enum JobType {
    UPDATE_GROUP_ANALYSIS = 'UPDATE_GROUP_ANALYSIS',
    CREATE_MUA_ANALYSIS = 'CREATE_MUA_ANALYSIS',
    MAPP_SEND_ANALYSIS_RESULT = 'MAPP_SEND_ANALYSIS_RESULT',
    UPDATE_ANALYSIS_WORK_STOCK = 'UPDATE_ANALYSIS_WORK_STOCK',
    SET_ANALYSIS_INVALID = 'SET_ANALYSIS_INVALID',
    DELETE_MUA_ANALYSIS = 'DELETE_MUA_ANALYSIS',
    CREATE_RISK_REGISTER = 'CREATE_RISK_REGISTER',
    GDMS_DOCUMENT_UPDATE_VALID_TO = 'GDMS_DOCUMENT_UPDATE_VALID_TO',
    REMOVE_DELETED_MAPP_TVG = 'REMOVE_DELETED_MAPP_TVG',
    CHANGE_MUA_HEADER_DATA = 'CHANGE_MUA_HEADER_DATA',
    KAFKA_SEND_ANALYSIS = 'KAFKA_SEND_ANALYSIS',
    DELETE_TVG = 'DELETE_TVG',
    DWSM = 'DWSM',
    DWSM_TMO = 'DWSM_TMO',
    DWSM_LITE = 'DWSM_LITE',
    DWSM_LITE_TMO = 'DWSM_LITE_TMO'
}
